<style lang="scss" scoped>
.menu-extra-dropdown {
    .dropdown-label {
        cursor: pointer;
        user-select: none;
        position: relative;

        &:after {
            content: "";
            position: absolute;
            width: 100%;
            left: 0;
            top: 100%;
            height: 32px;
        }
    }

    .mobile-dropdown-label {
        user-select: none;
    }

    .dropdown-menu {
        min-width: 160px;
        white-space: nowrap;
        right: 0;
        background-color: transparent;

        .wrapper {
            box-shadow: 0 0 20px -5px rgba(0, 0, 0, 0.2);
            background-color: var(--white);
        }

        a {
            color: var(--dark);
            text-decoration: none;
            padding: 12px 16px;

            &:hover {
                background-color: #fdeddc;
                color: var(--accent);
            }

            &.active {
                color: var(--accent);
            }
        }
    }

    .mobile-dropdown-menu {
        a {
            color: var(--white);

            @media screen and (max-width: 575px) {
                font-size: 1rem;
            }

            @media screen and (max-width: 320px) {
                font-size: 1.5rem;
            }

            text-decoration: none;

            &:hover {
                color: var(--accent);
            }
        }
    }
}
.hover-white {
    .navigation-overlay &.link-white:hover,
    &:hover {
        color: var(--white) !important;
    }
}
</style>

<template>
    <div class="d-inline position-relative menu-extra-dropdown" @mouseenter="toggleOpenHover" @mouseleave="toggleOpenHover" :class="{ 'font-weight-normal': active, 'font-weight-light': !active, 'hover-white': $root.isMobile && show }">
        <span v-if="$root.isMobile && show" @click.stop="toggleOpen" class="d-inline-flex align-items-center mobile-dropdown-label" :class="{ 'hover-white': $root.isMobile }">{{ label }}</span>
        <span v-else @click.stop="toggleOpen" class="d-inline-flex align-items-center dropdown-label">{{ label }}<i class="ml-8 fas xsmall" :class="{'fa-caret-down': !$root.isMobile, 'fa-caret-right': $root.isMobile}"></i></span>
        <slide-y-up-transition v-if="!$root.isMobile">
            <div v-if="show" class="position-absolute dropdown-menu text-left pt-16" v-click-outside="close">
                <div class="wrapper">
                    <a v-for="landingPage in visibleLandingPages" class="d-block small font-weight-light" :class="{active: activeSlug === `/nl/${landingPage.slug}`}" :href="`/nl/${landingPage.slug}`" :key="landingPage.id">{{ trimDot(landingPage.title.rendered) }}</a>
                </div>
            </div>
        </slide-y-up-transition>
        <div class="mobile-dropdown-menu mt-24" v-if="$root.isMobile && show">
            <a v-for="landingPage in visibleLandingPages" class="d-block mb-24" :class="{'font-weight-normal': activeSlug === `/nl/${landingPage.slug}`, 'font-weight-light': activeSlug !== `/nl/${landingPage.slug}`}" :href="`/nl/${landingPage.slug}`" :key="landingPage.id">{{ trimDot(landingPage.title.rendered) }}</a>
        </div>
    </div>
</template>

<script>
import ClickOutside from 'vue-click-outside'

export default {
    directives: {
        ClickOutside
    },

    props: {
        label: {
            type: String,
            required: true,
        },
        landingPages: {
            type: Array,
            default: () => []
        },
        open: {
            type: Boolean,
            default: null,
        }
    },

    data: () => ({
        visible: false
    }),

    methods: {
        toggleOpen() {
            if (this.open !== null) {
                this.$emit('change', !this.open)
                return
            }
            this.visible = !this.visible
        },

        toggleOpenHover() {
            if (document.documentElement.clientWidth >= 1280) {
                if (this.open !== null) {
                    this.$emit('change', !this.open)
                    return
                }
                this.visible = !this.visible
            }
        },

        close() {
            if (this.open !== null) {
                this.$emit('change', false)
                return
            }
            this.visible = false
        },

        trimDot(title) {
            if (title.length > 0 && title.charAt(title.length - 1) == '.') {
                title = title.substring(0, title.length - 1);
            }
            return title;
        }
    },

    computed: {
        activeSlug() {
            return window.location.pathname
        },
        active() {
            return this.visibleLandingPages.find(lp => `/nl/${lp.slug}` === this.activeSlug) !== undefined
        },
        show() {
            return this.open === null ? this.visible : this.open
        },
        visibleLandingPages() {
            return this.landingPages.filter(lp => !lp.acf || !lp.acf.options || !lp.acf.options.visibility || lp.acf.options.visibility.includes('menu_enabled'))
        }
    },
}
</script>